import { useStyletron } from 'baseui';

export function IconFan({ height, width, color }: any) {
    return (
        <svg width={width || '100%'} height={height || '100%'} x="0px" y="0px" viewBox="0 0 66 66" enableBackground="new 0 0 66 66" ><g>
            <path fill={color} d="M16.9,17c0,6.4,3.8,11.9,9.3,14.4c0.7-3.1,3.5-5.4,6.7-5.4V1C24.1,1.2,16.9,8.2,16.9,17z"></path>
            <path fill={color} d="M17,49.1c6.4,0,11.8-3.8,14.4-9.3c-3.1-0.7-5.4-3.5-5.4-6.7H1C1.1,41.9,8.2,49.1,17,49.1z"></path>
            <path fill={color} d="M49,49c0-6.4-3.8-11.8-9.2-14.4C39.1,37.7,36.3,40,33,40v25C41.9,64.9,49,57.8,49,49z"></path>
            <path fill={color} d="M49,17c-6.4,0-11.9,3.8-14.4,9.2c3.1,0.7,5.4,3.5,5.4,6.8h25C64.8,24.1,57.8,17,49,17z"></path>
            <path fill={color} d="M33.8,28.1C33.5,28,33.3,28,33,28h-0.1c-2.5,0-4.5,1.8-4.8,4.2c0,0.3-0.1,0.5-0.1,0.8v0.1c0,2.4,1.8,4.5,4.2,4.8   C32.4,38,32.7,38,33,38h0c2.5,0,4.5-1.8,4.9-4.2C38,33.6,38,33.3,38,33v0C38,30.5,36.2,28.5,33.8,28.1z M33,35c-1.1,0-2-0.9-2-2   c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C35,34.1,34.1,35,33,35z"></path></g></svg>
    );
}
